/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { FC } from 'react';

import { HighlightedSearch } from './styled';

const mergeIntervals = (intervals: [number, number][]) => {
  if (intervals.length === 0 || intervals.length === 1) return intervals;

  const sortedIntervals = [...intervals].sort((a, b) => {
    return a[0] - b[0];
  });

  const result = [sortedIntervals[0]];

  for (const interval of sortedIntervals) {
    const recentInterval = result[result.length - 1];
    if (recentInterval[1] >= interval[0]) {
      recentInterval[1] = Math.max(recentInterval[1], interval[1]);
    } else {
      result.push(interval);
    }
  }
  return result;
};

export const Highlighter: FC<Props> = ({ optionLabel: label, searchValue }) => {
  const optionLabel = label.toString();

  if (searchValue.length) {
    const matchIndexes = searchValue
      .filter(word => word.length)
      .reduce((acc: [number, number][], word: string) => {
        let startIndex = -1;
        while (
          (startIndex = optionLabel.toLowerCase().indexOf(word.toLowerCase(), startIndex + 1)) !==
          -1
        ) {
          const endIndex = startIndex + word.length;
          acc.push([startIndex, endIndex]);
        }
        return acc;
      }, []);

    if (matchIndexes.length) {
      const mergedMatchIndexes = mergeIntervals(matchIndexes);

      const prefix = {
        word: optionLabel.substring(0, mergedMatchIndexes[0][0]),
        highlighted: false,
      };
      const postfix = {
        word: optionLabel.substring(mergedMatchIndexes[mergedMatchIndexes.length - 1][1]),
        highlighted: false,
      };

      const chunks = mergedMatchIndexes.reduce(
        (
          acc: { word: string; highlighted: boolean }[],
          interval: [number, number],
          index,
        ): { word: string; highlighted: boolean }[] => {
          acc.push({
            word: optionLabel.substring(interval[0], interval[1]),
            highlighted: true,
          });

          const nextInterval = mergedMatchIndexes[index + 1];

          if (nextInterval) {
            acc.push({
              word: optionLabel.substring(interval[1], nextInterval[0]),
              highlighted: false,
            });
          } else {
            acc.push(postfix);
          }

          return acc;
        },
        [prefix],
      );

      return (
        <>
          {chunks.map(
            (chunk: {
              highlighted: any;
              word:
                | string
                | number
                | boolean
                | React.ReactElement<any, string | React.JSXElementConstructor<any>>
                | React.ReactFragment
                | React.ReactPortal
                | null
                | undefined;
            }) => {
              if (chunk.highlighted) {
                // eslint-disable-next-line react/jsx-key
                return <HighlightedSearch>{chunk.word}</HighlightedSearch>;
              }
              return chunk.word;
            },
          )}
        </>
      );
    }
  }

  return <>{optionLabel}</>;
};

type Props = {
  optionLabel: string | number;
  searchValue: string[];
};
